import { memo } from "react";
import Lottie from "react-lottie";
import styled from "styled-components";
import loadingData from "components/loading/loading-animation.json";

interface StyledLottieProps {
  $padding?: string;
  $color?: string;
  $backgroundColor?: string;
}

const StyledLottie = styled.div<StyledLottieProps>`
  div[aria-label="animation"] {
    padding: ${({ $padding }) => $padding};
    svg path {
      stroke-width: 66;
      transform: scale(250%);
      &[stroke-linecap="butt"] {
        stroke: ${({ $backgroundColor }) => $backgroundColor || "#a3a3a3"};
      }
      &[stroke-linecap="round"] {
        stroke: ${({ $color }) => $color};
      }
    }
  }
`;

export const LottieLoading = memo(
  ({
    size,
    className,
    color,
    backgroundColor,
    padding,
  }: {
    size: number;
    className?: string;
    color?: string;
    backgroundColor?: string;
    padding?: string;
  }) => {
    return (
      <StyledLottie
        className={className}
        $padding={padding}
        $color={color}
        $backgroundColor={backgroundColor}
      >
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: loadingData,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          height={size}
          width={size}
          isClickToPauseDisabled={true}
        />
      </StyledLottie>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.size === nextProps.size &&
      prevProps.className === nextProps.className &&
      prevProps.color === nextProps.color &&
      prevProps.backgroundColor === nextProps.backgroundColor &&
      prevProps.padding === nextProps.padding
    );
  }
);
